"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isZapOff_1 = __importDefault(require("./isZapOff"));
function isZapOn(zap) {
    return !isZapOff_1.default(zap);
}
exports.default = isZapOn;
